import { render, staticRenderFns } from "./ReportCheckListRemontJ.vue?vue&type=template&id=2f1837b4&scoped=true&"
import script from "./ReportCheckListRemontJ.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListRemontJ.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckListRemontJ.vue?vue&type=style&index=0&id=2f1837b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1837b4",
  null
  
)

export default component.exports
import {QBtn,QTable,QTr,QTh,QTd,QItemLabel,QItem,QInput,QField} from 'quasar'
component.options.components = Object.assign({QBtn,QTable,QTr,QTh,QTd,QItemLabel,QItem,QInput,QField}, component.options.components || {})
